require('./shared/helpers/form-validation');
import './order-detail-tabs';

import SimpleLightbox from 'simplelightbox';
import { initMegaNavigation } from './shared/components/mega-navigation';

window.addEventListener('load', () => {
  initMegaNavigation();

  const clickableMenuItems = document.getElementsByClassName('is-drilldown-submenu-parent');
  if (clickableMenuItems.length) {
    const offCanvasMenu = document.getElementById('offCanvas');
    for (let i = 0; i < clickableMenuItems.length; i++) {
      clickableMenuItems[i].addEventListener('click', function () {
        if (offCanvasMenu) {
          setTimeout(() => {
            offCanvasMenu.querySelector('.menu').scrollTop = 0;
          }, 100);
        }
      });
    }
  }

  document.querySelectorAll('.collapsible-button').forEach(button => {
    button.addEventListener('click', function()  {
      this.classList.toggle('--active');
      const content = this.nextElementSibling;

      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.lightbox__container');
  if(container) {
    let gallery = new SimpleLightbox('.lightbox__container a', {
      maxZoom: 5,
      loop: false,
      overlayOpacity: 0.6,
      navText: ['', ''],
      closeText: '',
      showCounter: false,
      animationSlide: false,
      animationSpeed: 50,
      fadeSpeed: 100,
    });
    container.classList.remove('lightbox__container--pending');

    gallery.on('changed.simplelightbox', function (e) {
      const mediaGallery = document.getElementById('mediaGallery');
      const blazeSlider = mediaGallery['blazeSlider'];

      const thumbnailGallery = document.getElementById('thumbnailGallery');
      const blazeSliderThumbnail = thumbnailGallery['blazeSlider'];

      const index = e.target.getAttribute('data-index');

      blazeSlider.slideTo(index);
      blazeSliderThumbnail.slideTo(index);
    });
  }

  const tooltip = document.querySelector(".tooltip");
  const content = tooltip?.querySelector(".__content") as HTMLElement;

  if (content) {
    content.style.display = "none"; // Initially hide content
  }

  tooltip?.addEventListener("click", function (event) {
    event.stopPropagation(); // Prevent click from bubbling up
    content.style.display = (content.style.display === "none") ? "block" : "none";
  });

  // Hide content when clicking outside
  document.addEventListener("click", function (event) {
    if(tooltip) {
      if (!tooltip.contains(event.target as Node)) {
        content.style.display = "none";
      }
    }
  });
});

